import { render, staticRenderFns } from "./boardAllRight.vue?vue&type=template&id=13f02cee&scoped=true&"
import script from "./boardAllRight.vue?vue&type=script&lang=js&"
export * from "./boardAllRight.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13f02cee",
  null
  
)

export default component.exports